<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M21.4 7.3c.4-.3.7-.4 1.1-.3.5.1 1 .4 1.4 0 .3-.3.1-.7-.2-1-.8-.8-2.1-.8-3.1-.4-1.6.7-2.7 2.2-2.9 3.8-.3 1.6.3 3.4 1.3 4.7.6.8 1.5 1.5 1.9 2.4.7 1.5 0 3.5-1.5 4.3-.2.2-.4.2-.5.2-.4 0-.7-.3-.8-.6-.1-.3-.1-.7 0-1.1.1-1.2.2-2.4 0-3.6-.5-2.9-2.7-5.4-5.5-6.4-1-.4-2.1-.5-3-1-.8-.2-1.6-.8-2.2-1.5.5-.3.8-1 .8-1.6-.1-.7-.5-1.4-.8-2.1-.3-.6-.2-1.8-.5-2.4-.5-.9-1 0-1.4.6-.5.6-1.2.9-2.5 1.1-.5.1-1 .1-1.5-.1-.6-.4-1.4-1-1.5 0C0 3 .6 4 .7 4.8c0 .7 0 1.5.3 2.2.3.5.8 1 1.4 1-.5.7-.6 1.6-.3 2.4.2.8.6 2.6 1.1 3.4.7 1.2 1.5 1.4 2.1 2.6.5 1 .9 2 .9 3.1s-.4 2.2-1.3 2.9c-.3.2-.6.4-.4.7.1.1.2.2.3.2.6.3 1.3.6 2 .3 1-.5.9-2 1.5-2.8.5.4 1.1.8 1.6 1.2-.5.2-1 .1-1.5.3-.5.2-.9.8-.5 1.1.2.1.4.2.6.2 2.3.2 4.5.2 6.8 0 .7-.1 1.4-.1 2.1-.2.7-.1 1.4-.2 2.2-.2.6-.1 1.3-.1 1.8-.4 1.2-.7 1.7-2.2 1.9-3.5.2-1.3.3-2.8-.4-3.9-.5-.8-1.2-1.3-1.8-2-1.1-1.4-1.2-3.5-.3-5.1.1-.5.4-.8.6-1z"
    />
  </svg>
</template>
